module.exports = __webpack_public_path__ + "static/media/human.1afc7abf.svg";